import styled from '@emotion/styled';
import React from 'react';
import { Color, MAX_WIDTH } from 'views/constants';

const Wrapper = styled.div`
  background-color: ${Color.C6};
  border-bottom-width: 1px;
  border-bottom-style: solid;
  border-bottom-color: ${Color.C14};
  padding: 16px;
`;

const ContentWrapper = styled.div`
  max-width: ${MAX_WIDTH};
  margin: auto;
`;

export const HeaderMenu: React.FC = ({ children }) => (
  <Wrapper>
    <ContentWrapper>{children}</ContentWrapper>
  </Wrapper>
);
